import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateMode } from "../../redux/reducers/ModeReducer";
import { authenticateUser } from "../../redux/reducers/UserReducer";
import ContentContainer from "../../components/ContentContainerComp/ContentContainer";
import { setUserCharacter } from "../../api/FakeApi";
import littleBoy from "../../assets/video/littleBoy.webm";
import littleGirl from "../../assets/video/littleGirl.webm";
import s from "./style.module.css";

const SelectCharacterContainer = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.UserInfo);
  const userId = localStorage.getItem("authUser");
  const handleSelectCharacter = (type) => {
    const data = { ...userInfo, character: type };
    dispatch(updateMode({ mode: 1, step: 2 }));
    dispatch(authenticateUser(data));
    setUserCharacter(data, userId);
  };

  return (
    <ContentContainer
      typeHeader={1}
      onCenter
      textHeader="ตัวละครของฉัน"
      textHeaderColor="#ffffff"
      disableNext={1}
      disableBack={1}
    >
      <div className={s.Container}>
        <div
          onClick={() => handleSelectCharacter(1)}
          className={s.CharacterWrapper}
        >
          <video width="400vw" autoPlay loop muted>
            <source src={littleBoy} />
          </video>
        </div>
        <div
          onClick={() => handleSelectCharacter(2)}
          className={s.CharacterWrapper}
        >
          <video width="400vw" autoPlay loop muted>
            <source src={littleGirl} />
          </video>
        </div>
      </div>
    </ContentContainer>
  );
};

export default SelectCharacterContainer;
